import type { Dispatch } from 'redux';
import type { AuthState, AuthAction } from '@/redux/auth/types';

export enum Actions {
  SetAuthData = 'SetAuthData',
  SetAuthDataFail = 'SetAuthDataFail'
}

export const setAuthData =
  (data: AuthState) => (dispatch: Dispatch<AuthAction>) => {
    const { refreshToken, refreshExpiresAt } = data;

    refreshToken
      ? window.localStorage.setItem('refreshToken', refreshToken)
      : window.localStorage.removeItem('refreshToken');

    refreshExpiresAt
      ? window.localStorage.setItem('refreshExpiresAt', `${refreshExpiresAt}`)
      : window.localStorage.removeItem('refreshExpiresAt');

    try {
      dispatch({ type: Actions.SetAuthData, data });
    } catch (error) {
      dispatch({ type: Actions.SetAuthDataFail, error });
    }
  };
